import { substringiqarkczpya5m as substring } from '../text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function charSequenceGet(a, index) {
  var tmp;
  if (isString(a)) {
    tmp = charCodeAt(a, index);
  } else {
    tmp = a.b(index);
  }
  return tmp;
}
function isString(a) {
  return typeof a === 'string';
}
function charCodeAt(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.charCodeAt(index);
}
function charSequenceLength(a) {
  var tmp;
  if (isString(a)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = a.length;
  } else {
    tmp = a.a();
  }
  return tmp;
}
function charSequenceSubSequence(a, startIndex, endIndex) {
  var tmp;
  if (isString(a)) {
    tmp = substring(a, startIndex, endIndex);
  } else {
    tmp = a.c(startIndex, endIndex);
  }
  return tmp;
}
//region block: exports
export {
  charCodeAt as charCodeAt1yspne1d8erbm,
  charSequenceGet as charSequenceGet1vxk1y5n17t1z,
  charSequenceLength as charSequenceLength3278n89t01tmv,
  charSequenceSubSequence as charSequenceSubSequence1iwpdba8s3jc7,
};
//endregion

//# sourceMappingURL=charSequenceJs.mjs.map
